module.exports = __webpack_public_path__ + "assets/member.797d7589.svg";